import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { onlyUniqueNonBlank } from '../../../lib/helpers/ArrayHelper';
import { getDeclaredContents } from '~/apps/smartsend/lib/parcels/itemView';

/**
 * Reads the declared contents rather than the order lines, so a SKU the user edited per parcel is
 * actually visible somewhere.
 *
 * That matters more than it looks: `OrderMapper` never maps Sku to the courier, so per-parcel SKU
 * editing exists purely for the customer's own records - display is its entire purpose. Before this,
 * editing a SKU on a parcel changed nothing the user could see.
 *
 * Single-parcel items are unaffected: getDeclaredContents synthesises contents from the order lines
 * when no parcel configuration is stored, so this returns exactly what it always did.
 */
export const GetSkus = (item: SmartSendItemApiModel): string[] =>
  getDeclaredContents(item)
    .map((x) => x.Sku)
    .filter(onlyUniqueNonBlank);
